/**
 * @module ol/events/KeyCode
 */

/**
 * @enum {number}
 * @const
 */
export default {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

//# sourceMappingURL=KeyCode.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/events/KeyCode.js
// module id = ../../../../ol/events/KeyCode.js
// module chunks = 3